import {FC, useEffect} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/fa'
import '@formatjs/intl-relativetimeformat/locale-data/ar'
import '@formatjs/intl-relativetimeformat/locale-data/de'
import '@formatjs/intl-relativetimeformat/locale-data/es'
import '@formatjs/intl-relativetimeformat/locale-data/fr'
import '@formatjs/intl-relativetimeformat/locale-data/ja'
import '@formatjs/intl-relativetimeformat/locale-data/tr'
import '@formatjs/intl-relativetimeformat/locale-data/zh'
import '@formatjs/intl-relativetimeformat/locale-data/ru'

import enMessages from './messages/en.json'
import faMessages from './messages/fa.json'
import arMessages from './messages/ar.json'
import deMessages from './messages/de.json'
import esMessages from './messages/es.json'
import frMessages from './messages/fr.json'
import jaMessages from './messages/ja.json'
import trMessages from './messages/tr.json'
import zhMessages from './messages/zh.json'
import ruMessages from './messages/ru.json'
import {WithChildren} from '../helpers'

const allMessages = {
  en: enMessages,
  fa: faMessages,
  ar: arMessages,
  de: deMessages,
  es: esMessages,
  fr: frMessages,
  ja: jaMessages,
  tr: trMessages,
  zh: zhMessages,
  ru: ruMessages,
}

const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale as keyof typeof allMessages] || enMessages

  useEffect(() => {
    const isRtl = locale === 'fa' || locale === 'ar'
    const dir = isRtl ? 'rtl' : 'ltr'
    const lang = locale
    document.documentElement.setAttribute('dir', dir)
    document.documentElement.setAttribute('lang', lang)
    document.body.setAttribute('dir', dir)
  }, [locale])

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
